import { Angular2SocialLoginModule } from "angular2-social-login";
import { LOGINENDPOINTS } from './environment';
var providers = {
    "google": {
        "clientId": LOGINENDPOINTS.GoogleClientId,
    },
    "linkedin": {
        "clientId": "LINKEDIN_CLIENT_ID"
    },
    "facebook": {
        "clientId": "FACEBOOK_CLIENT_ID",
        "apiVersion": "<version>" //like v2.4
    }
};
Angular2SocialLoginModule.loadProvidersScripts(providers);
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
//# sourceMappingURL=app.module.js.map